import React from "react";
import { Icon, Badge, Tooltip } from "antd";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { ReactComponent as MoreSvg } from "../../assets/icon/ic_more_horiz_24dp.svg";

import getChatEventActions from "../../utils/chatEvents.util";

import DatetimeFormat from "../DateTimeFormat";

function OptionsBox({
  chat,
  optionBoxOpenId,
  setOptionBoxRef,
  onOptionDivClick,
  toggleOptionsBox,
  direction,
  emitEvent,
  archiveChat,
  alternativeArchive,
  formatMessage,
  processInstance,
}) {
  const chatEventActions = getChatEventActions(
    chat,
    emitEvent,
    formatMessage,
    processInstance
  );

  return (
    <div className="option-box-container">
      <Tooltip
        title={<FormattedMessage id="tooltip.moreOptions" />}
        overlayClassName="social-tooltip"
      >
        <Icon
          className={`action-button ${
            optionBoxOpenId === chat.id ? "active" : ""
          }`}
          component={MoreSvg}
          onClick={(event) => toggleOptionsBox(event, chat)}
        />
      </Tooltip>

      {optionBoxOpenId === chat.id && (
        <div
          className={`message-box-options-box ${direction}`}
          ref={setOptionBoxRef}
          onClick={onOptionDivClick}
        >
          <div className="title">
            {formatMessage({ id: "general.message" })}
          </div>

          {chatEventActions}

          {chat.archived ? (
            <span className="message-box-option">
              {formatMessage({ id: "chat.noOptionsAvailable" })}
            </span>
          ) : (
            <span
              className="message-box-option"
              onClick={(e) => archiveChat(e, chat)}
            >
              {alternativeArchive
                ? formatMessage(
                    { id: alternativeArchive },
                    { flag: chat.flags[0].flagName }
                  )
                : formatMessage({ id: "chat.archiveMessage" })}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

function ChatItemOptions({
  chat,
  timestamp,
  unread,
  formatMessage,
  setOptionBoxRef,
  emitEvent,
  archiveChat,
  flags,
  optionBoxOpenId,
  optionBoxDirection,
  toggleOptionsBox,
  onOptionDivClick,
  processInstance,
}) {
  const chatConfig = window.Social.getChatConfig();
  let alternativeArchive;

  if (chatConfig.allowFlags && chat.flags && chat.flags.length === 1) {
    let currentFlag = flags.find((elem) => elem.id === chat.flags[0].id);
    if (currentFlag) {
      alternativeArchive = currentFlag.alternativeArchiveText;
    }
  }

  return (
    <div className="chat-item-options">
      <div className="right-info-options">
        <OptionsBox
          chat={chat}
          optionBoxOpenId={optionBoxOpenId}
          setOptionBoxRef={setOptionBoxRef}
          toggleOptionsBox={toggleOptionsBox}
          direction={optionBoxDirection}
          archiveChat={archiveChat}
          emitEvent={emitEvent}
          alternativeArchive={alternativeArchive}
          formatMessage={formatMessage}
          onOptionDivClick={onOptionDivClick}
          processInstance={processInstance[chat?.id]}
        />
      </div>

      <div className="right-info-time">
        <DatetimeFormat className="short" short dateTime={timestamp} />

        {unread > 0 && (
          <Badge className="unread-messages" count={unread} overflowCount={9} />
        )}
      </div>
    </div>
  );
}

export default connect((state) => ({
  processInstance: state.ProcessInstances,
}))(ChatItemOptions);
